import React, { useEffect, useState } from 'react'
import Cropper from 'react-easy-crop';
import Slider from 'react-rangeslider';
import "react-rangeslider/lib/index.css";
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import getCroppedImg from '../utility/crop-image-utils';

const CropImage = ({image, title, onComplete, isShow, setShow}) => {
    const [selectPic, setSelectPic] = useState(null);
    const [cropPic, setCropPic] = useState({x: 0, y: 0});
    const [zoomPic, setZoomPic] = useState(1);
    const [cropAreaPixel, setCropAreaPixel] = useState(null);

    useEffect(() => {
        if(image !== null){
            setSelectPic(image);
        }
    }, [image, isShow]);

    const OnCropCompleate = (croppedArea, croppedAreaPixel) => {
        setCropAreaPixel(croppedAreaPixel);
    };

    const OnCropImage = async () => {
        try{
            const { file, url } = await getCroppedImg(selectPic, cropAreaPixel, 0);
            const fileUse = new File([file], file.name, {type: file.type});
            onComplete(fileUse, url);
            setShow(false);
        }catch(error){
            console.log(error);
        }
    };

    return (
        <React.Fragment>
            <Modal id="modalCropImage"
                isOpen={isShow}
                size="lg"
                toggle={() => { setShow(false); }}
                backdrop={'static'}
                centered
            >
                <ModalHeader id="modalCropImageHeader"
                    className="modal-title"
                    toggle={() => { setShow(!isShow); }}
                >
                    {title}
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12} style={{height: "550px"}}>
                            {selectPic && (
                                <Cropper image={selectPic}
                                    crop={cropPic}
                                    zoom={zoomPic}
                                    aspect={3/3}
                                    onCropChange={setCropPic}
                                    onZoomChange={setZoomPic}
                                    onCropComplete={OnCropCompleate}
                                />
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Slider value={zoomPic}
                                min={1}
                                max={3}
                                step={0.1}
                                orientation="horizontal"
                                onChange={(value) => { setZoomPic(value); }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Button color="primary" type="button" onClick={() => setShow(false)}>
                                Close
                            </Button>
                            <Button className="float-end" color="success" type="button" onClick={() => OnCropImage()}>
                                Crop
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default CropImage;
